import './SonarTag.scss';
import classNames from 'classnames';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Tag } from 'antd';
import { Else, If, Then, When } from 'react-if';
import React, { useCallback } from 'react';
import { useCurrentUser, usePeriscopeActions, useTagReference } from '@hooks';

export interface SonarTagDisplayProps {
	noClick?: boolean;
	noBorder?: boolean;
	showDescription?: boolean;
	tagId: number;
}

export const SonarTagDisplay: React.FC<SonarTagDisplayProps> = ({ noClick, noBorder, showDescription, tagId }) => {
	const { description, hexColor, id, name } = useTagReference(tagId);
	const { openPeriscope } = usePeriscopeActions();
	const { isGuest } = useCurrentUser();

	const handleTagClick = useCallback(
		(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
			e.stopPropagation();

			openPeriscope({
				id,
				name,
				openedFromIndex: -1,
				type: SonarObjectType.SonarTag
			});
		},
		[ id, name, openPeriscope ]
	);

	if (!id) {
		return null;
	}

	const className = classNames('sonar-tag', { 'no-border': noBorder });

	const colorBlock = <span
		className='color-block'
		style={ { backgroundColor: hexColor } } />;

	return (
		<div className={ className }>
			<If condition={ noBorder }>
				<Then>
					{ colorBlock }
					{ name }
				</Then>
				<Else>
					<Tag
						icon={ colorBlock }
						onClick={ isGuest || noClick ? undefined : handleTagClick }>
						{ name }
					</Tag>
				</Else>
			</If>
			<When condition={ showDescription }>
				<span className='tag-description'>{ description }</span>
			</When>
		</div>
	);
};
